import { useGetApiV1ClassroomdisciplineSharedCourses } from '@/shared/api/generated';
import { mapDropdownOptions, useDebouncedFilter } from '@/shared/ui/molecules/LookupAutocomplete';

/**
 * Busca de cursos por texto (debounce + mínimo de 3 caracteres) para o
 * autocomplete de curso do modal "Adicionar Turma". Consome o lookup
 * `shared/courses` do Kubb — mesmo endpoint usado por `class-planning`
 * (`useCourseSearchDropdown`), duplicado aqui por regra de FSD (features não se
 * importam lateralmente).
 *
 * @param filter - Texto digitado no campo (default `''`).
 * @returns `{ options, isLoading, isQuerySuccess }`.
 */
export function useCourseSearchDropdown(filter = '') {
  const { debouncedFilter, isReady } = useDebouncedFilter(filter);

  const { data, isLoading, isSuccess } = useGetApiV1ClassroomdisciplineSharedCourses(
    isReady ? { Search: debouncedFilter } : undefined,
    { query: { enabled: isReady } },
  );

  return { options: mapDropdownOptions(data), isLoading, isQuerySuccess: isSuccess } as const;
}
